/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_With_OktaInputs */

const en_auth_login_with_okta = /** @type {(inputs: Auth_Login_With_OktaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign In with OKTA`)
};

/**
* | output |
* | --- |
* | "Sign In with OKTA" |
*
* @param {Auth_Login_With_OktaInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth_login_with_okta = /** @type {((inputs?: Auth_Login_With_OktaInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_With_OktaInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth_login_with_okta(inputs)
});